import { render, staticRenderFns } from "./RecommendedTraining.vue?vue&type=template&id=7dc20c82&scoped=true&"
import script from "./RecommendedTraining.vue?vue&type=script&lang=js&"
export * from "./RecommendedTraining.vue?vue&type=script&lang=js&"
import style0 from "./RecommendedTraining.vue?vue&type=style&index=0&id=7dc20c82&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc20c82",
  null
  
)

export default component.exports